import * as React from "react";
import { eBranches } from "sb-helpers";
import { Scoreboards } from "../../../../constants";
export const ServingIndicator = (props) => {
    const onServeTeamClass = props.event.score.additionalScores.onServe === props.onServe
        ? "rj-ev-list__indicator--serving"
        : "";
    return (Scoreboards[eBranches[props.event.sportId]]
        ? React.createElement("span", { className: `${onServeTeamClass} rj-ev-list__indicator`, "data-uat": "span-ev-list-indicator" })
        : React.createElement(React.Fragment, null));
};
//# sourceMappingURL=ServingIndicator.js.map